import { Card, CardContent, CardHeader, Button,TextField, Dialog, DialogContent,Grid, DialogContentText, 
  DialogActions, Divider,DialogTitle ,Stepper, Paper,Typography ,StepContent, StepLabel,Step,Input, Backdrop, CircularProgress} from "@material-ui/core";
import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import clsx from 'clsx';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import Substitution from './Substitution';
import ItemInfo from './ItemInfo';
import { useHistory } from 'react-router';
import AppReasonSearch from 'src/components/Selects/AppReasonSearch';
import MenuItem from '@material-ui/core/MenuItem';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTask } from '../../store/actions/taskActions';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CloseIcon from '@material-ui/icons/Close';
import CropFreeIcon from '@material-ui/icons/CropFree';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ErrorDialog from "src/components/ErrorDialog";
import BarkodPopup from 'src/components/BarcodePopup';
import {
  loadBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import {
  getUser
} from 'src/utils/Common';
const useStyles = makeStyles(theme => ({
    root: {},
    info: {
        marginTop: theme.spacing(0)
    },
    IconTop: {
        paddingTop: 0
    },
    submitButton: {
        marginTop: theme.spacing(2),
        width: '100%'
    },
    button: {
    marginTop: theme.spacing(1),
    width: '50%'
  },
  stepIcon: {
    "& .MuiStepIcon-root": {
      color: "#3B3030",
    },
    "& .MuiStepIcon-active": {
      color: "#3B3030",
    },
    "& .MuiStepIcon-completed": {
      color: "#3B3030",
    }
    },
    fields: {
      margin: theme.spacing(-1),
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        flexGrow: 1,
        margin: theme.spacing(1)
      }
    },
    search: {
      flexGrow: 1,
      height: 42,
      padding: theme.spacing(0, 2),
      display: 'flex',
      alignItems: 'center'
    },
    searchIcon: {
      marginRight: theme.spacing(2),
      color: theme.palette.icon
    },
    searchInput: {
      flexGrow: 1
    },
    submitButtonWudaq: {
      marginTop: theme.spacing(0),
      width: '100%'
    },
}));

function Operations({ className, readonly,ReceiptNo,tasks,setTask }) {
    const [openApproval, setOpenApproval] = React.useState(false);
    const [detail, setDetail] = React.useState(1)
    const { t } = useTranslation('work_order');
    const classes = useStyles();
    const [CopyWorkOrderPopup, setCopyWorkOrderPopup] = React.useState(false);
    const [EmployeeId, setEmployeeId] = useState(0);
    const [ServiceShopId, setServiceShopId] = useState(0);
    const [IssueId, setIssueId] = useState(0);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState('success');
    const [Uyari1, setUyari1] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [SubstitutionPopup, setSubstitutionPopup] = useState(false);
    const [ItemInfoPopup, setItemInfoPopup] = useState(false);
    const [FirstIssueType, setFirstIssueType] = useState(0);
    const [FirstType, setFirstType] = useState(0);
    const [LoadingControl, setLoadingControl] = useState(false);
    const history = useHistory();
    const SessionUser = getUser();
    const [EmployeeData, setEmployeeData] = useState([]);
    const [newWorkCaseData, setNewWorkCaseData] = useState([]);
    const [ReferenceWorkOrderOpen, setReferenceWorkOrderOpen] = useState(false);
    const search = '';
    const [ServiceShopData, setServiceShopData] = useState([]);
    const [ServiceShopSelected, setServiceShopSelected] = useState(null);
    const [ConsumerAddressId, setConsumerAddressId] = useState(0);
    const [SoftwareDownloadOpen, setSoftwareDownloadOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [messageErrorDialog, setMessageErrorDialog] = React.useState('');
    const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
    const [OpenBarkodCihaz, setOpenBarkodCihaz] = React.useState(false);
    const [DeviceBarcode, setDeviceBarcode] = React.useState('');
    const [response, setResponse] = React.useState("");
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    let SonlandirData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
    const SetCopyWorkOrder = (detail) => {
        handleCloseApproval();
        setCopyWorkOrderPopup(false);
        var employeeId = EmployeeId ? EmployeeId : SessionUser.TechnicianId;
        axios
            .post('/SetCopyWorkOrder/' + ReceiptNo + '/' + detail + '/' + IssueId + '/' + ServiceShopId + '/' + employeeId)
            .then(response => {
                var ResponseData = response.data[0];
                if (ResponseData.ErrorCode == 0) {
                    setUyariTip('success');
                    setUyari(true);
                    setOpen(true);

                } else {
                    setUyariTip('error');
                    setUyari(true);
                    setOpen(true);
                    setUyari1(ResponseData.ErrorMessage);
                }
            })
            .catch(error => { });
    }


    const handleCloseApproval = () => {
        setOpenApproval(false);
    };

    const handleOpenApproval = (detailData) => {
        setDetail(detailData);
        setOpenApproval(true);
    }

    const handleCloseForIssue = () => {
        setLoadingControl(true);
        axios
          .get(`/GetFirstIssueType/${ReceiptNo || 0}`)
          .then(response => {
            if (response.data.length > 0 && response.data != '') {
              if(FirstType == response.data[0].Type){
                setSubstitutionPopup(false)
              }
              else{
                setSubstitutionPopup(false)
                history.push('/overview');
              }
            }
            setLoadingControl(false);
          })
          .catch(error => {
            setUyariTip('error');
            setUyari(true);
            setLoadingControl(false);
          });
      };

    
      const getFirstIssueType = () => {
        axios
          .get(`/GetFirstIssueType/${ReceiptNo || 0}`)
          .then(response => {
            if (response.data.length > 0 && response.data != '') {
              setFirstIssueType(response.data[0].ControlHeader);
              setFirstType(response.data[0].Type);
            } else {
              setFirstIssueType(0);
              setFirstType(0);
            }
          })
          .catch(error => {
            setUyariTip('error');
            setUyari(true);
          });
      };

      useEffect(() => {
        getFirstIssueType();
      }, []);

      const GetSchedulingEmployee = ServiceShopId => {
        setEmployeeData([]);
        setEmployeeId('');
        axios
          .get(`/GetSchedulingEmployee/${ServiceShopId}`)
          .then(response => {
            if (response.data.length > 0) {
              var EmloyeeList = response.data;
              setEmployeeData(EmloyeeList);
              if (SonlandirData[0]?.EmployeeId || 0 > 0) {
                setEmployeeId(SonlandirData[0]?.EmployeeId);
              }
            }
          })
          .catch(error => { });
      };
    
      const GetSchedulingServiceShop = (ConsumerId, AddressId) => {
        setServiceShopData([]);
        setServiceShopId('');
        axios
          .get(`/GetSchedulingServiceShop/${ConsumerId}/${AddressId}/${ReceiptNo}/${SessionUser.Role}`)
          .then(response => {
            if (response.data.length > 0) {
              var ServiceShopList = response.data;
              setServiceShopData(ServiceShopList);
              if (ServiceShopList.length === 1 && parseInt(SonlandirData[0]?.ServiceShopId || 0) < 1) {
                setServiceShopId(ServiceShopList[0].Id);
                GetSchedulingEmployee(ServiceShopList[0].Id);
                return;
              }
    
              if (parseInt(SonlandirData[0]?.ServiceShopId || 0) > 0) {
                setServiceShopId(SonlandirData[0]?.ServiceShopId);
                var ServisData = ServiceShopList.filter(x => x.Id === SonlandirData[0]?.ServiceShopId);
                setServiceShopSelected(ServisData[0]);
                GetSchedulingEmployee(SonlandirData[0]?.ServiceShopId);
              }
    
            }
          })
          .catch(error => { });
      };
    
      useEffect(() => {
        if (SonlandirData[0]?.CustomerNo && SonlandirData[0]?.ConsumerAddressId) {
          GetSchedulingServiceShop(
            SonlandirData[0].CustomerNo,
            SonlandirData[0].ConsumerAddressId
          );
          setConsumerAddressId(SonlandirData[0].ConsumerAddressId);
        }
    
      }, [SonlandirData[0]?.CustomerNo]);
    
      const handleChangeServiceShopId = value => {
        setServiceShopSelected(value);
        setServiceShopId(value.Id);
        GetSchedulingEmployee(value.Id);
        let job = SonlandirData[0];
        job = {
          ...job,
          ServiceShopId: value.Id
        };
        setTask(job);
      };
    
      const handleChangeEmployeeId = event => {
        setEmployeeId(event.target.value);
    
        let job = SonlandirData[0];
        job = {
          ...job,
          EmployeeId: event.target.value
        };
        setTask(job);
      };
    
      const handleChangeIssueId = value => {
        setIssueId(value.Id);
        let job = { ...SonlandirData[0] };
        job.IssueId = value.Id;
        job.Issue = value.Dsc;
        setTask(job);
        setNewWorkCaseData(job);
      }

      function getSteps() {
        return [t('lblProductInfo'),
        t('lblDeviceInfo')];
      }

      function getStepContent(step) {
        switch (step) {
          case 0:
            return (
              <div>
                <Typography className={classes.title} color="textSecondary">
                  {t('lblBarkod')}
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                  {SonlandirData[0].Barcode}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                  {t('lblModelCode')}
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                  {SonlandirData[0].ModelCode}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                  {t('Urun')}
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                  {SonlandirData[0].Model}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                  {t('input_uyil')}
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                  {SonlandirData[0].ProductionYear}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                  {t('input_udonem')}
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                  {SonlandirData[0].ProductionMonth}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                  {t('input_serino')}
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                  {SonlandirData[0].SerialNumber}
                </Typography>
              </div>
            );
          case 1:
            return (
              <div className={classes.fields}>
                <Paper
                  className={classes.search}
                  elevation={1}
                >
                  <CropFreeIcon
                    onClick={handleCihazBarkodOpen}
                    className={classes.searchIcon}
                  />
                  <Input
                    className={classes.searchInput}
                    disableUnderline
                    value={DeviceBarcode}
                    onChange={(event) => { setDeviceBarcode(event.target.value); }}
                    placeholder={t('lblDeviceBarcode')}
                  />
                </Paper>
              </div>
            );
          default:
            return '';
        }
      }

      const handleNext = () => {
        if (activeStep !== steps.length - 1) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          return;
        }
        let user = getUser();
        let body = {
          UserName: user.UserId || '',
          BonaDeviceCode: DeviceBarcode || '',
          ModelCode: SonlandirData[0].ModelCode || '',
          ProductBarcode: SonlandirData[0].Barcode || '',
          WorkOrderId: SonlandirData[0].ReceiptNo || 0
        }
        const config = {
          headers: { 'Content-Type': 'application/json' }
        };
        setLoading(true);
    
        axios.post('/BonaDataCollection', body, config)
          .then(res => {
            setResponse(res.data.message);
            setLoading(false);
            setActiveStep(steps.length);
          }).catch(err => {
            setResponse(err.message);
            setLoading(false);
            setActiveStep(steps.length);
          });
      };

      const handleCihazBarkodClose = async (barkod) => {
        setDeviceBarcode(barkod);
        setOpenBarkodCihaz(false);
      };

      const GetBonaPdfData = async () => {
        const getFormattedFileName = () => {
          const date = new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/[/]/g, '-');
          return `${SonlandirData[0].Barcode}_${date}.pdf`;
        };
      
        try {
          setLoading(true);
          const WorkOrderId = ReceiptNo;
      
          const response = await axios.get(`/download-pdf?WorkOrderId=${WorkOrderId}`, { responseType: 'blob' });
      
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const result = reader.result;
              if (typeof result === 'string' && result.startsWith('{')) {
                const errorData = JSON.parse(result);
                setMessageErrorDialog(`${t('lblErrorPdf')}: ${errorData.title} - ${errorData.status}`);
                setOpenErrorDialog(true);
              } else {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
      
                link.download = getFormattedFileName();
      
                link.click();
                URL.revokeObjectURL(link.href);
              }
            } catch (error) {
              const file = new Blob([response.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(file);
      
              link.download = getFormattedFileName();
      
              link.click();
              URL.revokeObjectURL(link.href);
            }
          };
      
          reader.readAsText(response.data);
        } catch (error) {
          const errorMessage = error.response?.data
            ? `${t('lblErrorPdf')}: ${error.response.data.title} - ${error.response.data.status}`
            : `${t('lblErrorPdf')}: ${error.message}`;
          setMessageErrorDialog(errorMessage);
          setOpenErrorDialog(true);
        } finally {
          setLoading(false);
        }
      };


      const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };
    
      const handleReset = () => {
        setActiveStep(0);
      };
    
      const handleCihazBarkodOpen = () => {
        setOpenBarkodCihaz(true);
      };
    
    return (
        <div>
            <Card className={clsx(classes.root, className)}>
                {
                  loading
                    ? (
                    <Backdrop className={classes.backdrop} open={loading}>
                      <CircularProgress color="inherit" />
                     </Backdrop>
                    )
                    : <div />
                }
                <CardHeader title={t('lblOperations')} />
                <Divider />
                <CardContent>
                  {SessionUser.TenantId === 9 ?
                    <Grid item xs={12} sm={12} lg={12} align="right">
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.submitButton}
                        onClick={() => setReferenceWorkOrderOpen(true)}
                      >
                      {t('lblReferenceWorkOrder')}
                  </Button>
                    </Grid> : SessionUser.TenantId === 59 ? <Grid item xs={12} sm={12} lg={12} align="right">
                      <Button
                              variant="contained"
                              color="primary"
                              onClick={() => { setItemInfoPopup(true) }}
                              endIcon={<FindReplaceIcon />}
                              className={classes.submitButton}
                          >
                              {t('lblAddItemInfo')}
                          </Button>
                    </Grid> :
                    <div>
                      <Grid item xs={12} sm={12} lg={12} align="right">
                          <Button
                              variant="contained"
                              color="primary"
                              className={classes.submitButton}
                              onClick={() => handleOpenApproval(2)}
                          >
                              {t('lblExpenseWorkOrder')}
                          </Button>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12} align="right">
                          <Button
                              variant="contained"
                              color="primary"
                              className={classes.submitButton}
                              onClick={() => handleOpenApproval(1)}

                          >
                              {t('lblQuotationWorkOrder')}
                          </Button>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12} align="right">
                          <Button
                              variant="contained"
                              color="primary"
                              onClick={() => { setSubstitutionPopup(true) }}
                              endIcon={<FindReplaceIcon />}
                              className={classes.submitButton}
                              disabled={
                                  (FirstType == 16 || FirstType == 17) && (FirstIssueType != 1) ? true : false
                              }
                          >
                              {t('lblSubstitution')}
                          </Button>
                      </Grid> 
                      <Grid item xs={12} sm={12} lg={12} align="right">
                            <Button
                              variant="contained"
                              color="secondary"
                              className={classes.submitButton}
                              onClick={() => setSoftwareDownloadOpen(true)}
                              endIcon={<DeveloperBoardIcon />}
                            >
                              {t('lblBonaDataCollection')}
                            </Button>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12} align="right">
                            <Button
                              variant="contained"
                              color="secondary"
                              className={classes.submitButton}
                              onClick={() => GetBonaPdfData()}
                              endIcon={<PictureAsPdfIcon />}
                            >
                              {t('lblBonaDataPdf')}
                            </Button>
                      </Grid>
                    </div>
                  }
                </CardContent>
            </Card>
            <Dialog
                open={openApproval}
                onClose={handleCloseApproval}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {detail == 1 ? t('lblWithDetailWorkOrder') : detail == 2 ? t('lblWarrantyExpenseWorkOrder') : t('lblWithoutDetailWorkOrder')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseApproval} color="primary">
                        {t('iptal')}
                    </Button>
                    <Button onClick={() => SetCopyWorkOrder(detail)} color="primary" autoFocus>
                        {t('lblContinue')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
              open={SubstitutionPopup}
              onClose={handleCloseForIssue}
            >
              <DialogContent>
                <Substitution ReceiptNo={ReceiptNo} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseForIssue} 
                color="primary"
                >
                  {t('Tamam')}
                </Button>
              </DialogActions>
            </Dialog>
             {/* -------Item Info-------- */}
            <Dialog
              open={ItemInfoPopup}
              onClose={()=>setItemInfoPopup(false)}
            >
              <DialogContent>
                <ItemInfo ReceiptNo={ReceiptNo} />
              </DialogContent>
              <DialogActions>
                <Button onClick={()=>setItemInfoPopup(false)} 
                color="primary"
                >
                  {t('Tamam')}
                </Button>
              </DialogActions>
            </Dialog>
            {/* -----------------------------------*/}
            {/* -------Reference Work Order-------- */}
            <Dialog
            open={ReferenceWorkOrderOpen}
            onClose={() => setReferenceWorkOrderOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogContent>
              <Card>
                <CardHeader title={t('lblReferenceWorkOrder')} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        autoSelect
                        disableClearable
                        value={ServiceShopSelected || null}
                        options={ServiceShopData || []}
                        getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                        getOptionSelected={(option, value) => option.Id === value.Id}
                        renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined"
                        />}
                        onChange={(event, value) => { handleChangeServiceShopId(value); }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblEmployee')}
                        id="EmployeeId"
                        onChange={handleChangeEmployeeId}
                        value={EmployeeId}
                        variant="outlined"
                      >
                        {EmployeeData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <AppReasonSearch
                        setIssue={handleChangeIssueId}
                        value={
                          {
                            Dsc: newWorkCaseData.Issue || '',
                            Id: newWorkCaseData.IssueId || 0
                          } || ''
                        }
                        searchParam={search}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <div className={classes.wrapper}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => handleOpenApproval(0)}
                    endIcon={<AddBoxRoundedIcon fontSize="small" />}
                  >
                    {t('lblCreate')}
                  </Button>
                </div>
              </Card>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setReferenceWorkOrderOpen(false)} color="primary">
                {t('Tamam')}
              </Button>
            </DialogActions>
            </Dialog>
            {/* -----------------------------------*/}
            {/* --------Bona-------- */}
            <Dialog
            open={SoftwareDownloadOpen}
            onClose={() => setSoftwareDownloadOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen
          >
            <DialogTitle id="alert-dialog-title">
              {t('lblBonaDataCollection')}
              <Divider />
            </DialogTitle>

            <DialogContent>
              <Stepper
                activeStep={activeStep}
                orientation="vertical"
              >
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel classes={{ iconContainer: classes.stepIcon }}>{label}</StepLabel>
                    <StepContent>
                      <br />
                      <br />
                      {getStepContent(index)}
                      <br />
                      <br />
                      <div className={classes.actionsContainer}>
                        <div>
                          <Button
                            disabled={activeStep === 0}
                            variant="contained"
                            onClick={handleBack}
                            startIcon={<KeyboardArrowLeft />}
                            className={classes.button}
                            style={{
                              backgroundColor: activeStep === 0 ? "#D3D3D3" : "#B6A28E",
                              color: activeStep === 0 ? "#A9A9A9" : "white",
                            }}
                          >
                            {t('lblBack')}
                          </Button>

                          <Button
                            variant="contained"
                            style={{ backgroundColor: "#685752", color: "white" }}
                            onClick={handleNext}
                            endIcon={<KeyboardArrowRight />}
                            className={classes.button}
                          >
                            {activeStep === steps.length - 1 ? t('lblInstall') : t('lblNext')}
                          </Button>
                        </div>
                      </div>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
              {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                  <Typography>{response}</Typography>
                  <Button onClick={handleReset} className={classes.button}>
                    {t('lblReset')}
                  </Button>
                </Paper>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                style={{ backgroundColor: "#B6A28E", color: "white" }}
                onClick={() => setSoftwareDownloadOpen(false)}
                className={classes.submitButtonWudaq}
                endIcon={<CloseIcon>Close</CloseIcon>}
              >
                {t('lblClose')}
              </Button>

            </DialogActions>
            </Dialog>
            <BarkodPopup onClose={handleCihazBarkodClose} open={OpenBarkodCihaz} ScanTime={1000} />
            {/* --------------------*/}
            <ErrorDialog open={openErrorDialog} onClose={() => setOpenErrorDialog(false)} message={messageErrorDialog} />
        </div>
    )
}

Operations.propTypes = {
  className: PropTypes.string,
};
export default connect((state) => ({
  tasks: state.tasks1,
  materialReducer: state.materialReducer,
  defectReducer: state.defectReducer,
  labourReducer: state.labourReducer
}), { setTask })(Operations);
